import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OrderByPipe } from './order-by.pipe';
import { OrderControlComponent } from './order-control/order-control.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [OrderByPipe, OrderControlComponent],
  exports: [OrderByPipe, OrderControlComponent]
})
export class OrderByModule { }
